export default "__VITE_ASSET__ddzFwz4Q__"